<script setup lang="ts">
import { ref } from 'vue';
import { func, string } from 'vue-types';
import { Button, Modal, notification } from 'ant-design-vue';
import type { ButtonType } from 'ant-design-vue/lib/button';

import FileCreateForm from './FileCreateForm.vue';

import {
  useFileCreateMutation,
  type FileFragmentFragment,
} from '@/graphql/generated/graphql';

const props = defineProps({
  onSuccess: func<(file: FileFragmentFragment) => void>(),
  btnTitle: string().def('Upload file'),
  modalTitle: string().def('Upload file'),
  btnType: string<ButtonType>().def('primary'),
});

const { fetching, error, executeMutation } = useFileCreateMutation();
const visible = ref(false);

const setVisible = (value: boolean) => {
  if (!fetching.value) {
    visible.value = value;
  }
};

const onFormSubmit = async (file: File) => {
  const response = await executeMutation({ file });
  if (response.data?.fileCreate) {
    notification.success({ message: 'File uploaded' });
    setVisible(false);
    if (props.onSuccess) {
      props.onSuccess(response.data.fileCreate);
    }
  } else if (response.error) {
    notification.error({ message: response.error.message });
  }
};

const onCancel = () => {
  setVisible(false);
};
</script>

<template>
  <Button :type="btnType" @click="() => setVisible(true)">
    {{ btnTitle }}
  </Button>
  <Modal
    :title="modalTitle"
    :open="visible"
    :confirm-loading="fetching"
    :footer="false"
    width="520px"
    @cancel="onCancel"
  >
    <FileCreateForm
      v-if="visible"
      :fetching="fetching"
      :error="error"
      @submit="onFormSubmit"
      @cancel="onCancel"
    />
  </Modal>
</template>
